import { ModelHelper } from '../classes/model-helper';
import { RestorationElement } from './restorationE-element.model';

export class Restoration {
	uid: string;
	type: string;
	restorationElements: RestorationElement[];

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Restoration
	 */
	static map(data: any, item: Restoration = new Restoration()): Restoration {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Restoration
	 */
	public map(data: any): Restoration {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'type');
		ModelHelper.map(data, this, 'restorationElements', RestorationElement);

		return this;
	}
}
